import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Slider from "react-slick";
import CEO from "../assets/equipe/amine.png";
import TEAMLEAD from "../assets/equipe/nesrine.png";
import PROJECTMANAGER from "../assets/equipe/karim.png";
import BUSSNESS from "../assets/equipe/zied.png";
import PROJECTMANAGERSOLUTION from "../assets/equipe/adnen.png";
import PROJECTMANAGERWEB from "../assets/equipe/ahmed.png";
import MARKETING from "../assets/equipe/sara.png";
import INFRAMANAGER from "../assets/equipe/mohamedmaher.png";
import SYSTEMDEV from "../assets/equipe/oussama.png";
import GRAPHICDESIGN from "../assets/equipe/salma.png";
import GRAPHICDESIGNS from "../assets/equipe/amani.png";
import FRONTDEV from "../assets/equipe/aymen.png";
import TEAMWEB from "../assets/equipe/hayfa.png";
import MOBILEDEV from "../assets/equipe/khaled.png";
import MOBILEDEVIOS from "../assets/equipe/radhia.png";
import MARKETINGASSISTANT from "../assets/equipe/emna.png";
import BACKDEV from "../assets/equipe/mohamedali.png";
import FULLDEV from "../assets/equipe/borhene.png";
import ADMINASSIST from "../assets/equipe/molka.png";
import fullstackweb from "../assets/equipe/amal.png";
import tarek from "../assets/equipe/tarek.png";

/*import icofb from "../assets/icone_equipe/ico_fb_equipe.svg";
import icogoogle from "../assets/icone_equipe/ico_google_equipe.svg";
import icotwit from "../assets/icone_equipe/ico_twitter_equipe.svg";*/
import icolink from "../assets/icone_equipe/ico_linkedin_equipe.svg";

import axios from "axios";
import ReactSVG from "react-svg";
import "./style/team.css";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    margin: "auto",
    maxWidth: 500,
  },
  image: {
    width: 128,
    height: 128,
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
});
const Employer = (props) => (<div>
  {props.imageDirection === "right" ? 
  <div className="flex-container-team">
    <div style={{ overflow: "hidden" }}>
      <img
        className="imageTeam"
        alt="complex"
        src={
          `${process.env.REACT_APP_SERVER}` +
          "/images/" +
          props.employer.EmployerImage
        }
      />
    </div>
    <div>
      <div className="text-team">
        <div>
          <h2 className="nameTeam">
            {props.employer.Firstname}
            {props.employer.Lastname}
          </h2>
        </div>
        <div style={{ marginTop: "-20px" }}>
          <p className="posteTitle">{props.employer.position}</p>
        </div>
        <div>
          <p className="paragPers">{props.employer.quote}</p>{" "}
        </div>
        <div className="ImagesRxSoc">
          {/* <div style={{marginRight: "13px"}}>
              <ReactSVG src={icofb}/>
            </div>
            <div style={{marginRight: "13px"}}>
              <ReactSVG src={icotwit}/>
            </div>
            <div style={{marginRight: "13px"}}>
              <ReactSVG src={icogoogle}/>
            </div> */}
          <div>
            <ReactSVG src={icolink} />
          </div>
        </div>
      </div>
    </div>
  </div> :  
  <div className="flex-container-team">
    <div>
      <div className="text-team">
        <div>
          <h2 className="nameTeam">
            {props.employer.Firstname}
            {props.employer.Lastname}
          </h2>
        </div>
        <div style={{ marginTop: "-20px" }}>
          <p className="posteTitle">{props.employer.position}</p>
        </div>
        <div>
          <p className="paragPers">{props.employer.quote}</p>{" "}
        </div>
        <div className="ImagesRxSoc">
          {/* <div style={{marginRight: "13px"}}>
              <ReactSVG src={icofb}/>
            </div>
            <div style={{marginRight: "13px"}}>
              <ReactSVG src={icotwit}/>
            </div>
            <div style={{marginRight: "13px"}}>
              <ReactSVG src={icogoogle}/>
            </div> */}
          <div>
            <ReactSVG src={icolink} />
          </div>
        </div>
      </div>
    </div>
    <div style={{ overflow: "hidden" }}>
      <img
        className="imageTeam"
        alt="complex"
        src={
          `${process.env.REACT_APP_SERVER}` +
          "/images/" +
          props.employer.EmployerImage
        }
      />
    </div>
  </div>} </div>
);
class Team extends Component {
  constructor(props) {
    super(props);

    this.state = {
      employers: [],
    };
  }
  componentDidMount() {
    axios
      .get(`${process.env.REACT_APP_SERVER}` + "/employers")
      .then((response) => {
        this.setState({ employers: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  employerList() {
    return this.state.employers.map((currentemployer , index ) => {
      return <Employer employer={currentemployer} imageDirection={index % 2 ===0 ?"left" : "right" } key={currentemployer._id} />  ;
    });
  }
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      rows: 2,
      slidesToScroll: 2,
      arrows: false,
      className: "teamcar",

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            rows: 1,
            autoplay: false,
            infinite: true,
            dots: false,
            arrows: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 1,
            dots: false,
            arrows: true,
          },
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 1,
            speed: 5000,
            autoplay: true,
            dots: false,
            arrows: false,
          },
        },
        /*{
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 1,
          }
        }*/
      ],
    };

    return (
      <div>
        <h2
          style={{
            color: "#171850",
            fontFamily: "Oswald",
            textAlign: "center",
            fontSize: "30px",
            textTransform: "uppercase",
            paddingTop: "20px",
            letterSpacing: "8px",
            wordSpacing: "3px",
          }}
        >
          {" "}
          Découvrez notre équipe{" "}
        </h2>

        <Slider {...settings}>
          {this.employerList()}
        </Slider>
      </div>
    );
  }
}

Team.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Team);



// WEBPACK FOOTER //
// ./src/home/team.js